const BASE_ACTION_TYPE = 'LANDLORD::RESIDENT_DETAILS::ACTIVITY_FEED';

export const GET_AMENITY_BOOKINGS = `${BASE_ACTION_TYPE}::GET_AMENITY_BOOKINGS`;
export const GET_NOTICES = `${BASE_ACTION_TYPE}::GET_NOTICES`;
export const GET_EVENTS = `${BASE_ACTION_TYPE}::GET_EVENTS`;
